import { IconPdfPrinter } from 'components/NavBar/svg';
import { ExportPDFButton } from '../../styles';

interface PrintContainerProps {
  title?: string;
  buttonLabel: string;
  disabled?: boolean; 
  containerId: string; 
}

export default function PrintContainer({ title, buttonLabel, disabled, containerId}: PrintContainerProps) {
  const print = () => {
    const content = document.getElementById(containerId);
    if (!content) return;

    const printWindow = window.open('', 'print-window', 'width=1200,height=920');
    printWindow.document.title = title || 'Print Document';

    if (!printWindow) return;

    printWindow.document.write(`
      <html>
        <head>
          <title>${title}</title>
          <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
        </head>
        <body class="p-4">
          ${content.innerHTML}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      setTimeout(() => {
        printWindow.close(); //fecha apos impressao iniciar
      }, 1000);
    
     //tempo para renderizar antes de imprimir
    }, 200); 
  };

  return (
    <div className="space-y-4">
      <ExportPDFButton data-testid="test-go-to-button-print" 
                      id="btnExportPDF" 
                      type="button" 
                      disabled={disabled}
                      onClick={print}  >
          <div className="flex items-center justify-center gap-2">
              <IconPdfPrinter/>
              <span>{buttonLabel}</span>
          </div>
      </ExportPDFButton>
    </div>
  );
};